// extracted by mini-css-extract-plugin
module.exports =  {"icon_color":"#95979d","iconColor":"#95979d","tag":"_NHcEPZ","button":"HiEd9NU"};